import { render } from "./BNavItem.vue?vue&type=template&id=e00a6952"
import script from "./BNavItem.vue?vue&type=script&lang=js"
export * from "./BNavItem.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__